import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { store } from './modules/ewwms/store';
import App from './App.vue';
import router from './routes';

import { registerSW } from 'virtual:pwa-register';
import { useAuthStore } from '@/modules/auth/stores/authStore';

import 'bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core';

import { faWindows } from '@fortawesome/free-brands-svg-icons';

import {
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faChevronLeft,
  faCircleCheck,
  faCircleInfo,
  faBarcode,
  faBars,
  faBoxesStacked,
  faClipboard,
  faEnvelope,
  faFileDownload,
  faFileWaveform,
  faFloppyDisk,
  faMagnifyingGlassPlus,
  faMinus,
  faPaperPlane,
  faPen,
  faPlus,
  faPrint,
  faRotate,
  faTableList,
  faTruckArrowRight,
  faTruckFast,
  faTruckRampBox,
  faTrash,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faChevronLeft,
  faCircleCheck,
  faCircleInfo,
  faBarcode,
  faBars,
  faBoxesStacked,
  faClipboard,
  faEnvelope,
  faFileDownload,
  faFileWaveform,
  faFloppyDisk,
  faMagnifyingGlassPlus,
  faMinus,
  faPaperPlane,
  faPen,
  faPlus,
  faPrint,
  faRotate,
  faTableList,
  faTruckArrowRight,
  faTruckFast,
  faTruckRampBox,
  faTrash,
  faWindows,
  faXmark
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

registerSW({ immediate: true });

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());

  app.use(store); // Vuex Store einbinden, solange Vuex noch verwendet wird

  app.use(router);
  app.component('font-awesome-icon', FontAwesomeIcon);

  const auth = useAuthStore();
  await auth.initAuth();

  if (!auth.isAuthenticated) {
    router.push({ name: 'auth.login' });
    // auth.login();
  }
  // else {
  //   console.log(router.currentRoute);
  //   router.push({ name: 'ewwms.bestellungen' });
  // }

  app.mount('#app');
}

bootstrap();
